// test2507
(2507 && 0);
